import React, { useMemo, useState } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import { useEffect } from "react";
import { getTermsAndCondition } from "../services";
import Skeleton from "../auth/component/skeleton";
import DOMPurify from "dompurify";
import Card from "../../components/card/card";
import { useNavigate } from "react-router-dom";
import { routerPath } from "../../navigation/path";
import CoverflowCarousel from "../auth/component/coverflow";

// Word(s) inside the API-delivered about-us content that should be rendered
// as a highlighted "badge". Wraps the first whole-word, case-insensitive
// match of each word with a span the app can style via CSS (see
// `.highlight-badge` in src/index.css) — no changes needed on the CMS side.
const HIGHLIGHTED_WORDS = ["Mighty"];

const highlightWords = (html, words) => {
  if (!html) return html;
  return words.reduce((acc, word) => {
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`\\b(${escaped})\\b`, "i");
    return acc.replace(regex, '<span class="highlight-badge">$1</span>');
  }, html);
};

const About = () => {
  const [aboutUs, setAboutus] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getAboutUs();
  }, []);

  const getAboutUs = async () => {
    try {
      const res = await getTermsAndCondition("about_us");
      console.log(res.data[0]);
      await setAboutus(res?.data[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const offerClick = (e) => {
    console.log("offer clicked", e);
    navigate(`${routerPath.claimOffer}?offer_id=${e.id}`);
  };

  const aboutUsContent = useMemo(
    () =>
      DOMPurify.sanitize(highlightWords(aboutUs.content, HIGHLIGHTED_WORDS)),
    [aboutUs.content],
  );

  return (
    <>
      <Header />
      <div className="grid grid-cols-1 bg-white">
        <div className="container mx-auto max-w-7xl px-4">
          {/* Hero banner: standalone, hardcoded marketing card. */}
          <div className="mt-6 rounded-2xl bg-gradient-to-b from-[#0A142F] to-[#1B2A5E] px-4 py-8 sm:py-10 text-center">
            <h2 className="text-2xl sm:text-4xl font-bold text-white">
              The <span className="highlight-badge">Shopping Club</span>{" "}
              Membership
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm sm:text-base text-white/80">
              The only Membership with 30+ Subscriptions &amp; Benefits from 40+
              Brands and Upto 10 lac+ rewards. Access to Exclusive Events and
              Movie Premieres.
            </p>
          </div>

          {/* CMS-driven about-us copy, kept separate from the hero card so it
              reads naturally on the page's white background. */}
          {aboutUs.content && (
            <div
              className="mt-6 max-w-3xl mx-auto text-center text-gray-700"
              dangerouslySetInnerHTML={{ __html: aboutUsContent }}
            ></div>
          )}

          {loading && aboutUs?.offer_details?.length < 0 ? (
            <>
              <div className="flex flex-col items-center bg-white shadow-md rounded-lg p-4">
                <Skeleton width="100%" />
              </div>
            </>
          ) : (
            <div className="mb-2">
              <CoverflowCarousel offers={aboutUs.offer_details} />
            </div>
          )}

          <div className="text-center mb-5">
            <button
              type="button"
              onClick={() => navigate(routerPath.purchasePlan)}
              className="mt-6 bg-gradient-to-b from-[#0A142F] to-[#1B2A5E] inline-flex items-center gap-2 rounded-full px-8 py-3 text-sm sm:text-base font-bold text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-2xl hover:bg-amber-400 hover:text-[#0A142F]"
            >
              Subscribe Now
              <span aria-hidden="true">&rarr;</span>
            </button>
          </div>

          {/* {!loading && aboutUs?.offer_details?.length > 0 && (
            <div className="mb-4">
              <h3 className="ps-2 mt-5 font-semibold text-center text-white">Line up of Special Offers worth Rs. 1,00,000 exclusively for You</h3>
              <CoverflowCarousel offers={aboutUs.offer_details} />
            </div>
          )} */}
          {/* <h3 className="ps-2 mt-5 font-semibold">
            Line up of Special Offers worth Rs. 1,00,000 exclusively for You
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-3 gap-2">
            {loading ? (
              [1, 2, 3, 4].map((e, i) => (
                <div className="px-2 overflow-hidden py-2" key={e + i}>
                  <Skeleton />
                </div>
              ))
            ) : (
              <>
                {aboutUs.offer_details &&
                  aboutUs.offer_details
                    .map((e, i) => (
                      <div className="px-2 overflow-hidden" key={e.id}>
                        <Card
                          cardType="Heading"
                          title={e?.name}
                          img={e?.image1}
                          click={() => offerClick(e)}
                        />
                      </div>
                    ))
                    .slice(0, 4)}
              </>
            )}
          </div> */}
        </div>
      </div>
      {/* <Footer /> */}
      <Footer />
    </>
  );
};

export default About;
